var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"left-line"},[_c('div',{staticClass:"title"},[_vm._v(" 视频报警统计波图 "),_c('img',{attrs:{"src":require("@/assets/img/eduBigData/time-bg.png"),"alt":""}})])]),_c('div',{attrs:{"id":"echart"}})])
}]

export { render, staticRenderFns }